module.exports = __webpack_public_path__ + "assets/img/2051591928118_.pic_hd.2e41b258.jpg";